import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Stack,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
  import SearchIcon from '@mui/icons-material/Search';
  import { useEffect, useState } from 'react';
import api from '@src/api/clients';
import { Link } from 'react-router-dom';
import { ClientDropdown, VerticalDropdown } from '@src/components';
  

  export default function LeadListPage() {
    const [leads, setLeads] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    phone: '',
    email: '',
    id: '',
    client: '',
    zip_code: '',
    source: '',
    vertical: '',
    success_post: 'false',
  });
  
  const pageSize = 100;

  const fetchLeads = async (pageParam = page) => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: pageParam,
        ...Object.fromEntries(
          Object.entries(filters).filter(([_, v]) => v !== '')
        ),
      }).toString();
      const res = await api.request({ url: `dashboard/leads/?${params}`, method: 'GET' });
      setLeads(res.data.results);
      setTotalPages(Math.ceil(res.data.count / pageSize));
    } catch (err) {
      console.error('Error fetching leads:', err);
    } finally {
      setLoading(false);
    }
  };
  
    useEffect(() => {
      fetchLeads(page);
    }, [page]);

    const handleSearch = () => {
      const newPage = 1;
      setPage(newPage);
      fetchLeads(newPage);
    };
  
  const handleInputChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
  };

  const renderBooleanDropdown = (label, field) => (
    <FormControl size="small" sx={{ minWidth: 140 }}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={filters[field]}
        onChange={(e) => handleInputChange(field, e.target.value)}
        label={label}
      >
        <MenuItem value=""><em>Any</em></MenuItem>
        <MenuItem value="true">Yes</MenuItem>
        <MenuItem value="false">No</MenuItem>
      </Select>
    </FormControl>
  );
  
    return (
      <Box p={3}>
        <Card>
          <CardHeader title="Leads" />
          <Divider />
          <CardContent>
            <Stack direction="row" spacing={2} mb={2} flexWrap="wrap" alignItems="center">
              <TextField
                label="Phone"
                value={filters.phone}
                onChange={(e) => handleInputChange('phone', e.target.value)}
                size="small"
              />
              <TextField
                label="Email"
                value={filters.email}
                onChange={(e) => handleInputChange('email', e.target.value)}
                size="small"
              />
              <TextField
                label="Lead ID"
                value={filters.id}
                onChange={(e) => handleInputChange('id', e.target.value)}
                size="small"
              />
              <Box sx={{ minWidth: 200 }}>
                <ClientDropdown
                  value={filters.client}
                  onChange={(value) => handleInputChange('client', value)}
                />
              </Box>
              <Box sx={{ minWidth: 200 }}>
                <VerticalDropdown
                  value={filters.vertical}
                  onChange={(value) => handleInputChange('vertical', value)}
                />
              </Box>
              <TextField
                label="ZIP Code"
                value={filters.zip_code}
                onChange={(e) => handleInputChange('zip_code', e.target.value)}
                size="small"
              />
              <TextField
                label="Source"
                value={filters.source}
                onChange={(e) => handleInputChange('source', e.target.value)}
                size="small"
              />
              {renderBooleanDropdown('Success Post', 'success_post')}
              <Button
                variant="contained"
                startIcon={<SearchIcon />}
                onClick={handleSearch}
                sx={{ height: 40 }}
              >
                Search
              </Button>
            </Stack>
  
            <TableContainer component={Paper}>
              <Table size="small">
              <TableHead>
                <TableRow>
                    <TableCell>Client</TableCell>
                    <TableCell>Date Created (EST)</TableCell>
                    <TableCell>Date Sent (EST)</TableCell>
                    <TableCell>First Name</TableCell>
                    <TableCell>Last Name</TableCell>
                    <TableCell>Phone</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Source</TableCell>
                    <TableCell>Territory</TableCell>
                    <TableCell>ZIP Code</TableCell>
                    <TableCell>Self-Book Appt</TableCell>
                    <TableCell>Vertical</TableCell>
                    <TableCell>Processed</TableCell>
                    <TableCell>Success Post</TableCell>
                    <TableCell>Post Response</TableCell>
                    <TableCell>Sold Date</TableCell>
                    <TableCell>Net Amount</TableCell>
                    <TableCell>Issue</TableCell>






                </TableRow>
                </TableHead>
                <TableBody>
                    {leads.map((lead) => {
                        const toEST = (utc) =>
                        utc ? new Date(utc).toLocaleString('en-US', { timeZone: 'America/New_York' }) : '-';
                        const backend = lead.related_backend_data?.[0];  // Just the most recent match


                        return (
                        <TableRow key={lead.id}>
                            <TableCell>{lead.client_name || '-'}</TableCell>
                            <TableCell>{toEST(lead.date_created)}</TableCell>
                            <TableCell>{toEST(lead.webhook_sent_datetime)}</TableCell>
                            <TableCell>
                            <Link to={`/leads/${lead.id}`} style={{ textDecoration: 'none', color: '#2f80ed' }}>
                                {lead.first_name || 'View'}
                            </Link>
                            </TableCell>
                            <TableCell>{lead.last_name || '-'}</TableCell>
                            <TableCell>{lead.phone || '-'}</TableCell>
                            <TableCell>{lead.email || '-'}</TableCell>
                            <TableCell>{lead.source || '-'}</TableCell>
                            <TableCell>{lead.territory || '-'}</TableCell>
                            <TableCell>{lead.zip_code || '-'}</TableCell>
                            <TableCell>{lead.self_book_appointment_date_time}</TableCell>
                            <TableCell>{lead.vertical || '-'}</TableCell>
                            <TableCell>{lead.processed ? '✅' : '❌'}</TableCell>
                            <TableCell>{lead.success_post ? '✅' : '❌'}</TableCell>
                            <TableCell>{lead.post_response || '-'}</TableCell>
                            <TableCell>{backend?.sold_date || '-'}</TableCell>
                            <TableCell>{backend?.net_amount ? `$${backend.net_amount}` : '-'}</TableCell>
                            <TableCell>{backend?.issue ? '✅' : '❌'}</TableCell>


                        </TableRow>
                        );
                    })}
                    {leads.length === 0 && (
                        <TableRow>
                        <TableCell colSpan={14} align="center">
                            {loading ? 'Loading...' : 'No leads found.'}
                        </TableCell>
                        </TableRow>
                    )}
                    </TableBody>

              </Table>
            </TableContainer>
  
            <Stack direction="row" justifyContent="flex-end" mt={2}>
              <Pagination
                count={totalPages}
                page={page}
                onChange={(_, value) => setPage(value)}
                color="primary"
                shape="rounded"
              />
            </Stack>
          </CardContent>
        </Card>
      </Box>
    );
  }
  